import { render, staticRenderFns } from "./DetailPosFlight.vue?vue&type=template&id=46309cb8&"
import script from "./DetailPosFlight.vue?vue&type=script&lang=js&"
export * from "./DetailPosFlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports